(function() {
  var __blocks__ = {};
  (function() {
    var element = document.getElementById("blocks-script");
    var attribute = a = element ? element.getAttribute("data-blocks") : '';
    var blocks = a.split(",").filter(Boolean);

    for (var i = 0; i < blocks.length; i++) {
      __blocks__[blocks[i]] = true;
    }
  })();
  (function() {
  if (!__blocks__["contact-form"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('contactForm', () => ({}));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["filters"] && !Shopify.designMode) return;
  try {
    class FilterDropdown {
    constructor(id) {
      this.id = id;
    }

    get isOpen() {
      return Alpine.store('filterListPanel').openId === this.id;
    }

    toggle() {
      const store = Alpine.store('filterListPanel');
      store.openId = store.openId === this.id ? '' : this.id;
    }

    closeIfOpen() {
      const store = Alpine.store('filterListPanel');
      if (store.openId === this.id) {
        store.openId = '';
      }
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('filterDropdown', (...args) => new FilterDropdown(...args));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["newsletter"] && !Shopify.designMode) return;
  try {
    document.addEventListener('alpine:init', () => {
    Alpine.data('newsletterForm', () => ({}));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["pagination"] && !Shopify.designMode) return;
  try {
    class Pagination {
    constructor(paginationId, loaderId, nextId, currentId) {
      this.paginationId = paginationId;
      this.loaderId = loaderId;
      this.nextId = nextId;
      this.currentId = currentId;
    }

    get nextElement() {
      return document.getElementById(this.nextId);
    }

    get currentElement() {
      return document.getElementById(this.currentId);
    }

    fetchNext() {
      if (this.nextElement) {
        this.$ajax(this.nextElement, {
          targets: [this.paginationId, this.loaderId],
          sync: true,
          headers: { 'X-Alpine-Pagination': +this.currentElement.innerText + 1 },
        });
      }
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('pagination', (...args) => new Pagination(...args));
  });
  } catch(e) { console.error(e); }
})();

(function() {
  if (!__blocks__["product-quote-form"] && !Shopify.designMode) return;
  try {
    class ProductQuoteForm {
    selectedUnit = 'metric';
    selectedThicknessId = null;
    selectedFormatHandle = null;
    selectedVariantId = null;
    fileName = '';
    area = '';
    submitting = false;

    constructor(dataId) {
      // Parse data from script tag to avoid HTML entity escaping issues
      const dataEl = document.getElementById(dataId);
      const data = JSON.parse(dataEl.textContent);
      this.formats = data.formats;
      this.variants = data.variants;
      const initialVariantId = data.initialVariantId;

      // Find initial variant and set state
      const initialVariant = this.variants.find((v) => v.id === initialVariantId);
      if (initialVariant) {
        this.selectedVariantId = initialVariantId;
        this.selectedFormatHandle = initialVariant.formatHandle;

        // Find format to get thickness and unit
        const format = this.formats.find((f) => f.handle === initialVariant.formatHandle);
        if (format) {
          this.selectedUnit = format.unitSystem;
          this.selectedThicknessId = format.thicknessId;
        }
      } else {
        // Default to customer's country-based unit system
        this.selectedUnit = data.defaultUnit;
        this.selectedThicknessId = this.visibleThicknesses[0]?.id || null;
      }
    }

    // ─────────────────────────────────────────────────────────────
    // Computed properties
    // ─────────────────────────────────────────────────────────────

    get visibleThicknesses() {
      const seen = new Set();
      const thicknesses = [];

      for (const format of this.formats) {
        if (format.unitSystem !== this.selectedUnit) continue;
        if (seen.has(format.thicknessId)) continue;
        seen.add(format.thicknessId);

        // Check if any variant with this thickness is available
        const available = this.variants.some((v) => {
          const f = this.formats.find((fmt) => fmt.handle === v.formatHandle);
          return f && f.thicknessId === format.thicknessId && v.available;
        });

        thicknesses.push({
          id: format.thicknessId,
          display: format.thicknessDisplay,
          unit: format.thicknessUnit,
          available,
        });
      }

      return thicknesses;
    }

    get visibleFormats() {
      return this.formats.filter(
        (f) => f.unitSystem === this.selectedUnit && f.thicknessId === this.selectedThicknessId && !f.isCustom
      );
    }

    get rectangularFormats() {
      return this.visibleFormats
        .filter((f) => f.width !== f.length)
        .map((f) => ({
          ...f,
          available: this.variants.some((v) => v.formatHandle === f.handle && v.available),
        }));
    }

    get squareFormats() {
      return this.visibleFormats
        .filter((f) => f.width === f.length)
        .map((f) => ({
          ...f,
          available: this.variants.some((v) => v.formatHandle === f.handle && v.available),
        }));
    }

    get visibleCustomFormats() {
      return this.formats
        .filter((f) => f.isCustom && f.unitSystem === this.selectedUnit && f.thicknessId === this.selectedThicknessId)
        .map((f) => ({
          ...f,
          available: this.variants.some((v) => v.formatHandle === f.handle && v.available),
        }));
    }

    get visibleFinishes() {
      return this.variants.filter((v) => v.formatHandle === this.selectedFormatHandle);
    }

    get isCustomFormatSelected() {
      const format = this.formats.find((f) => f.handle === this.selectedFormatHandle);
      return format?.isCustom || false;
    }

    get selectedVariantAvailable() {
      const variant = this.variants.find((v) => v.id === this.selectedVariantId);
      return variant?.available || false;
    }

    get canAddToCart() {
      const variant = this.variants.find((v) => v.id === this.selectedVariantId);
      if (!variant) return false;
      if (!variant.inventoryManagement || variant.inventoryPolicy !== 'deny') return true;
      return variant.cartQuantity < variant.inventoryQuantity;
    }

    // Units, thickness, format, finish, and area are all mandatory;
    // area plans only when a custom size is selected
    get canSubmit() {
      return (
        !!this.selectedUnit &&
        !!this.selectedThicknessId &&
        !!this.selectedFormatHandle &&
        !!this.selectedVariantId &&
        parseFloat(this.area) > 0 &&
        (!this.isCustomFormatSelected || !!this.fileName) &&
        this.canAddToCart
      );
    }

    // ─────────────────────────────────────────────────────────────
    // Actions
    // ─────────────────────────────────────────────────────────────

    selectUnit(unit) {
      if (this.selectedUnit === unit) return;
      this.selectedUnit = unit;

      // Select first available thickness
      const firstThickness = this.visibleThicknesses.find((t) => t.available) || this.visibleThicknesses[0];
      this.selectedThicknessId = firstThickness?.id || null;

      // Area is unit-dependent so it resets
      this.area = '';
      this.selectDefaultFormat();
    }

    selectThickness(thicknessId) {
      if (this.selectedThicknessId === thicknessId) return;
      this.selectedThicknessId = thicknessId;
      this.selectDefaultFormat();
    }

    selectDefaultFormat() {
      // Standard formats only, in display order (rectangular column first)
      const candidates = [...this.rectangularFormats, ...this.squareFormats];
      const defaultFormat = candidates.find((f) => f.available) || candidates[0];

      if (defaultFormat) {
        this.selectFormat(defaultFormat.handle);
      } else {
        this.selectedFormatHandle = null;
        this.selectedVariantId = null;
      }
    }

    selectFormat(formatHandle) {
      this.selectedFormatHandle = formatHandle;

      // Auto-select best finish variant
      const currentVariant = this.variants.find((v) => v.id === this.selectedVariantId);
      const currentFinish = currentVariant?.finishHandle;
      const matchingVariants = this.variants.filter((v) => v.formatHandle === formatHandle);
      const available = matchingVariants.filter((v) => v.available);

      const bestMatch =
        available.find((v) => v.finishHandle === currentFinish) ||
        available[0] ||
        matchingVariants.find((v) => v.finishHandle === currentFinish) ||
        matchingVariants[0];

      if (bestMatch) {
        this.selectedVariantId = bestMatch.id;
        this.updateUrl(bestMatch.id);
      } else {
        // No variant exists for this format: a finish must be re-picked,
        // never submit one belonging to a previously selected format
        this.selectedVariantId = null;
      }
    }

    selectVariant(variantId) {
      this.selectedVariantId = variantId;
      this.updateUrl(variantId);
    }

    clearUpload() {
      this.fileName = '';
      if (this.$refs.fileInput) this.$refs.fileInput.value = '';
    }

    updateUrl(variantId) {
      const url = new URL(window.location.href);
      url.searchParams.set('variant', variantId);
      history.replaceState({}, '', url);
    }
  }

  document.addEventListener('alpine:init', () => {
    Alpine.data('productQuoteForm', (...args) => new ProductQuoteForm(...args));
  });
  } catch(e) { console.error(e); }
})();

})();
